import React, { useState } from 'react'
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import { formatRelative } from "date-fns";
import camera from "../svg/camera.svg";
import compass from "../svg/compass.svg";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import "@reach/combobox/styles.css";
// import mapStyles from "../mapStyles";

const libraries = ["places"];
const containerStyle = {
  width: '700px',
  height: '400px'
};

/*  If you want different map style(ENABLE THESE(mapStyles.js, pass options={options} down to GoogleMap))  */

// const options = {
//   styles: mapStyles,
//   disableDefaultUI: true,
//   zoomControl: true,
// };

const center = {
  lat: 40.7831,
  lng: -73.9712
};

function LocationSearch() {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries,
  });

  const [markers, setMarkers] = useState([])
  const [selected, setSelected] = React.useState(null);

  const onMapClick = React.useCallback((event) => {
      setMarkers(current => [
      ...current, 
      {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
        time: new Date(),
    }])
  }, [])

  const mapRef = React.useRef();
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    map.fitBounds(bounds);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  const panTo = React.useCallback(({lat, lng}) => {
    mapRef.current.panTo({lat, lng});
    mapRef.current.setZoom(18);
  }, []);

  return isLoaded ? (
    <div className="google-map">
      <h1> 
        Search Location{" "} 
        <span role="img" aria-label="camera">
          📸
        </span>
      </h1>

      <Search panTo={panTo}/>
      <Locate panTo={panTo}/>

      <GoogleMap
        zoom={8}
        center={center}
        onLoad={onLoad}
        onLoad={onMapLoad}
        onClick={onMapClick}
        onUnmount={onUnmount}
        mapContainerStyle={containerStyle}
        // options={options}
      >
          {markers.map((marker) => (
            <Marker 
              key={marker.time.toISOString()} 
              position={{lat: marker.lat, lng: marker.lng}}
              icon={camera}
              onClick={() => {
                setSelected(marker);
              }}
            />
          ))}

          {selected ? (
          <InfoWindow 
          position={{ lat: selected.lat, lng: selected.lng }}
          onCloseClick={() => {
            setSelected(null);
          }}
          >
                <div>
                <h2>
                <span role="img" aria-label="camera">
                  📸
                </span>{" "}
                Spotted
              </h2>
                  <p>Spotted {formatRelative(selected.time, new Date())}</p>
                </div>
          </InfoWindow>
          ) : null }
        <Marker position={{ lat: 40.713468006091794, lng: -74.0150387326917}} />
        { /* Child components, such as markers, info windows, etc. */ }
        <></>
      </GoogleMap>
    </div>
  ) : <></>
}

    const Locate = ({ panTo }) => {
      return (
        <button className="locate" onClick={() => {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              panTo({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              });
            }, 
            () => null
          );
        }}
      >
          <img src={compass} alt="locate me" />
        </button>
      )
    }

    const Search = ({ panTo }) => {
      const {
        ready, 
        value, 
        suggestions: { status, data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
          requestOptions: {
            location: { lat: () => 40.7831, lng: () => -73.9712},
            radius: 200 * 1000,
          },
      });

      return (
        <div className="map-search">
        <Combobox 
          onSelect={async (address) => {
            setValue(address, false);
            clearSuggestions();
            try {
              const results = await getGeocode({address});
              const { lat, lng } = await getLatLng(results[0]);
              panTo({ lat, lng });
              console.log(lat, lng);
            } catch(error) {
              console.log("error!")
            }
              }}
          >
            <ComboboxInput 
            value={value} 
            onChange={(e) => {
              setValue(e.target.value);
              }}
              disable={!ready}
              placeholder="Enter an location..."
            />
            <ComboboxPopover>
                <ComboboxList>
                {status === "OK" && 
                  data.map(({id, description}) => (
                    <ComboboxOption key={id} value={description} />
                  ))}
                </ComboboxList>
            </ComboboxPopover>
        </Combobox>
        </div>
      );
    }

export default LocationSearch;